import React from 'react'
import TooltipInputError from '../toolTip/ToolTipInputError'
import { FormControl, TextField } from '@material-ui/core'

function NameField({
   fieldLabel,
   fieldName,
   formValue,
   fieldInvalid,
   handleChange,
   maxLength
}) {
   return (
      <FormControl fullWidth>
         <TextField
            error={fieldInvalid}
            value={formValue}
            onChange={handleChange}
            inputProps={{ maxLength }}
            InputProps={{
               endAdornment: formValue?.length === maxLength && (
                  <TooltipInputError
                     title={`El número permitido de caracteres es de máximo ${maxLength}.`}
                  />
               )
            }}
            label={fieldLabel}
            name={fieldName || 'name'}
            helperText={
               fieldInvalid
                  ? formValue === ''
                     ? 'El campo Nombre es obligatorio.'
                     : 'Introduzca un Nombre válido.'
                  : ''
            }
            variant="outlined"
            size="small"
            margin="normal"
         />
      </FormControl>
   )
}

export default NameField
